import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_493edh35w5: FaireBrandEntity = {
  token: "b_493edh35w5",
  type: "brand",
  name: "MOND HAUS",
  avatarUrl:
    "https://cdn.faire.com/fastly/2b4442006ec90c45771118fa06987e6ec118e7c52272d91878eb2755ca774bcc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8f7e6c14696a624b749cef47f435e7e842e005f1ccddb86079b3baf7145fa5a5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2b4442006ec90c45771118fa06987e6ec118e7c52272d91878eb2755ca774bcc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8f7e6c14696a624b749cef47f435e7e842e005f1ccddb86079b3baf7145fa5a5.jpeg",
  location: "Hacienda Heights, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.2,
  reviewCount: 5,
  isInsider: true,
  description:
    "Welcome to MOND HAUS, your ultimate destination for unique and enchanting handmade jewelry designs.\n\nAt MOND HAUS, we are excited to bring you a thoughtfully curated collection of dreamy jewelry that will instantly capture your heart. Our goal is to provide you with exceptional pieces that are carefully crafted with love and attention to detail, and infused with a warm and inviting aesthetic.\n\nOur jewelry stands out with its poetic and one-of-a-kind designs, created to inspire a sense of wonder and delight. Each item carries a touch of magic, lovingly wrapped in a friendly embrace that invites you to explore your style and express yourself with confidence.\n\nEmbark on a delightful journey where elegance meets artistry, and experience the friendly allure of our dreamy jewelry designs.\n\nWelcome once again to MOND HAUS, where enchantment meets a friendly smile, and dreams come to life.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.531Z",
    importedBy: "entity-db-cli",
  },
};
